import {default as Component} from './AddDomainForm'
import {changeDomain} from '../../redux/actions'
import { addDomain, refresh } from '../../redux/endpointActions'
import {connect} from 'react-redux'

const servicePath = process.env.REACT_APP_SERVICE_ENDPOINT + 'user/domain'
const tokenPath = process.env.REACT_APP_SERVICE_ENDPOINT + 'user/token'

const AddDomainForm = connect(
	(state) => ({
		domain: state.addDomainForm.domain,
		disabled: state.addDomainForm.disabled,
		err: state.addDomainForm.err,
		addDomain: (state.login.isLoggedIn ? addDomain(servicePath,
			state.login.userToken.AuthenticationResult.AccessToken,
			state.login.userToken.AuthenticationResult.IdToken) : () => (() => {
		})),
		refreshToken: (state.login.isLoggedIn ? refresh(tokenPath,
			state.login.userToken.AuthenticationResult.RefreshToken) : () => (() => {
		}))
	}),
	(dispatch) => ({
		domainChanged: (domain) => {
			dispatch(changeDomain(domain))
		},
		dispatch: dispatch
	}),
	(stateProps, dispatcherProps) => ({
		domain: stateProps.domain,
		disabled: stateProps.disabled,
		err: stateProps.err,
		domainChanged: dispatcherProps.domainChanged,
		submit: (domain) => {
			stateProps.addDomain(domain)(dispatcherProps.dispatch)
			.then((data) => {
				return stateProps.refreshToken()(dispatcherProps.dispatch)
			})
		},
	})
)(Component)

AddDomainForm.defaultProps = {
	domain: null,
	disabled: null,
	domainChanged: null,
	submit: null
}

export default AddDomainForm  


// WEBPACK FOOTER //
// ./src/components/AddDomainForm/index.js